export const WorkData = [
  {
    id: 1,
    number: "",
    image: "/images/oa.png",
    title: "Software Engineer",
    desicription:
      "Developing & implementing held all kinds of finance side tasks like cashiering, invoicing, accounting, development of reports and other financial task.",

    tech: [
      {
        Laravel: "/images/icons/laravel.svg",
        Codeigniter: "images/icons/codeigniter.svg",
        Php: "/images/icons/php.svg",
        // Springboot: "/images/icons/springboot.png",
        Java: "/images/icons/java.svg",
        Mysql: "/images/icons/mysql.svg",
        jQuery: "/images/icons/jquery.svg",
        Html: "/images/icons/html.svg",
        Css: "/images/icons/css.svg",
        Javascript: "/images/icons/javascript.svg",
        Bootstrap: "/images/icons/bootstrap.svg",
      },
    ],
    oa_url: "https://orangeapps.ph/",
    btn_img_icon: "/images/icons/oa.png",
  },
  {
    id: 2,
    number: "01",
    image: "/images/work1.png",
    title: "Caraevents \n Management System",
    desicription:
      "Caraevents is a reservation system built in Laravel Application that focuses on inquiry thru reservations and advertising the client's events services. It also have features like renting events planning etc.",

    tech: [
      {
        Laravel: "/images/icons/laravel.svg",
        Php: "/images/icons/php.svg",
        Mysql: "/images/icons/mysql.svg",
        Bootstrap: "/images/icons/bootstrap.svg",
      },
    ],
    github_url: "https://github.com/iamante/caraevents",
  },
  {
    id: 3,
    number: "02",
    image: "/images/work2.png",
    title: "Reactjs \n Personal Portfolio",
    desicription:
      "Personal portfolio built with Reactjs to enhance my knowledge in react using react hooks, dynamic data and DRY pattern and also in mockups designing using figma.",

    tech: [
      {
        React: "/images/icons/react.svg",
        Figma: "/images/icons/figma.svg",
      },
    ],
    github_url: "https://github.com/iamante/iamante_v2",
    figma_url:
      "https://www.figma.com/file/Jw5E8L6YCNukimmA4EFV2F/James-Portfolio?node-id=0%3A1",
  },
];
